import { ActionType } from "./action_types";
import { Action, State } from "../reducers/user_reducer";

export const updateUser = function (user: State): Action {
  return {
    type: ActionType.UPDATE_USER as const,
    user,
  };
};
